export enum SPACE_ONBOARDING_STEP_ID {
  PARTICIPANTS = 'participants',
  INVITE_BTN = 'invite-btn',
  INVITE_MODAL = 'invite-modal',
  TEAMS = 'teams',
  TEAM_CREATE_BTN = 'create-team-btn',
  TEAM_CREATE_MODAL = 'team-create-modal',
  TEAM_ITEM = 'team-item',
  POKER_SESSION_CREATE_BTN = 'poker-session-create-btn',
  POKER_SESSION_CREATE_MODAL = 'poker-session-crete-modal',
  POKER_SESSION_TEAMS_EDIT_MODAL = 'poker-session-teams-edit-modal',
}
